export default __webpack_public_path__ + "static/media/36.1d22f436.svg";